import { DayPicker } from "react-day-picker";
import "react-day-picker/style.css";

export type CalendarProps = React.ComponentProps<typeof DayPicker>;

const Calendar = ({ className, ...props }: CalendarProps) => (
  <DayPicker className={`service-date-picker ${className || ""}`} showOutsideDays {...props} />
);

export { Calendar };